import React, { useState, useEffect } from "react";
import { Input, Table, FormGroup, Button, Col, Row } from "reactstrap";

import { DropdownList } from "react-widgets";
import {
  PostApiWithAuthorizationAction,
  GetApiActionWithAuthorization
} from "constantFunctions/apiActions";
import { toast } from "react-toastify";
import { formValid } from "constantFunctions/formValidations";
import { itemType, itemMaterial } from "../../../constants/ticketConstants";

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { enableFileItemUploader } from "../../../libs/common";

function AddCoinItems(props) {
  const defaultVal = {
    itemType: "3 Jewelry",
    description: "",
    serial: "",
    model: "",
    qty: 1,
    name: "",
    unit: "0.00",
    cost: ""
  };
  const quantityOptions = Array.from({ length: 50 }, (_, i) => i + 1);
  const [ethSpotPrice, setETHSpotPrice] = useState(0);
  const [btcSpotPrice, setBTCSpotPrice] = useState(0);
  const [newItems, setNewItems] = useState([defaultVal]);
  const [maxRows, setMaxRows] = useState(10);
  const [metroItems, setMetroItems] = useState([]);
  const [requiredItemDescriptions, setRequiredItemDescriptions] = useState([]);

  useEffect(() => {
    GetApiActionWithAuthorization("common/get-items-select-options")
    .then((res) => {
      setMetroItems(res.data);
      return  GetApiActionWithAuthorization("item-descriptions/get-all-data")
    })
    .then((res) => {
      let descriptions = [];
      res.data.forEach(function(item) {
        descriptions.push(item.keyword);
      });
      setRequiredItemDescriptions(descriptions)
    })
    .catch((err) => {
      if (err.status === 440) {
        toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
        props.history.push("/auth/login");
      } else {
        console.log(err);
        toast.error("Something went wrong! /n Please clear and retry", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    });
  }, []);

  const changeItemValues = (name, value, index) => {
    let temp = newItems;
    let itemObj = temp[index];
    itemObj[name] = value;
    temp[index] = itemObj;
    if (name === "price") {
      itemObj["price"] = parseFloat(value).toFixed(2);
    }
    setNewItems([... temp]);
  };

  const handleAutoFormSubmit = (e, i) => {
    //apply logic only when ENTER hit or TAB hit
    if ((e.key === 'Enter' || e.key === "Tab") && !document.getElementById("add-all-items").disabled) {
      e.preventDefault()
      handleSubmit()
    }
  };

  const handleKeyDown = event => {
    let _key = event.key
    //apply logic only when ENTER hit
    if (_key === 'Enter') {
      let index = event.target.id.replace(/\D/g, ""),
          findItem = newItems[index],
          items = [...newItems],
          material = findItem.description.split(". ")[0].trim(),
          description = findItem.description.split(". ")[1].trim();
      /**
       * index is last item
       * fields filled
       * then add new row
       */
      if (((newItems.length-1) == index) && material.length > 0 && description.length > 0) {
        items.push({
          itemType: findItem.itemType,
          description: findItem.description.split(". ")[0].trim(),
          model: '',
          serial: ''
        });
        setNewItems([... items]);
      }
    }
    //
    setTimeout(function() {
      if ((_key === 'Enter' || _key === "Tab")
          && !document.getElementById("add-all-items").disabled) {
        event.preventDefault()
        handleSubmit()
      }
    }, 10)
  };
  const addNewItemInList = (e) => {
    let body = {
      ticketId: props.id,
      items: newItems.map((it) => {
        return {
          itemId: it.name.id,
          cost: it.cost,
          unit: it.unit,
          qty: ["eth", "btc"].includes(it.name.name.toLowerCase())
            ? it.qty / 0.00000001
            : it.qty,
          description: it.description ? it.description : null
        };
      }),
      /*itemId: newItem.name.id,
      cost: newItem.cost,
      unit: newItem.unit,
      qty: ["eth", "btc"].includes(newItem.name.name.toLowerCase())
        ? newItem.qty / 0.00000001
        : newItem.qty,*/
    };
    let appendQuery = (props.isBarter) ? "barter=true" : "";
    if (appendQuery.length > 0) {
      appendQuery = "?" + appendQuery;
    }
    PostApiWithAuthorizationAction("coin-tickets/add-new-item-in-edit" + appendQuery, body)
      .then((res) => {
        if (props.isBarter) {
          props.fetchCoinBarterItemsListingSuccess({ data: res.data })
        } else {
          props.fetchCoinItemsListingSuccess({ data: res.data })
        }
        setNewItems([{ qty: 1, name: "", description: "", unit: "0.00", cost: "" }]);
        setTimeout(() => {
          for(let saveItem of res.saveItems) {
            enableFileItemUploader("[id^='fileuploader-" + saveItem.id + "']", props.isBarter);
            window.jQuery("[id^='fileuploader-" + saveItem.id + "']").show();
          }
        }, 100);
      })
      .catch((err) => {
        console.log(err);
        if (err.status === 440) {
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        } else {
          toast.error("Something went wrong! /n Please clear and retry", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      });
  };
  const addRowBelow = (i) => {
    if (newItems.length < maxRows) {
      let lastItem = newItems[i];
      let items = [...newItems];
      let maxRows = 10;
      //items.splice(i + 1, 0, defaultVal);
      for(i=0; i<(maxRows-newItems.length); i++) {
        items.push({
          itemType: lastItem.itemType,
          description: lastItem.description.split(". ")[0].trim(),
          model: '',
          serial: '',
          qty: 1,
          name: "",
          unit: "0.00",
          cost: ""
        });
      }
      setNewItems([... items]);
    } else {
      toast.error("*Maximum limit(10) of add items exceeded", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };
  const removeRow = (i) => {
    if (newItems.length > 1) {
      let items = [...newItems];
      items.splice(i, 1);
      setNewItems(items);
    } else {
      toast.error("*Can't remove, Atleast 1 item required", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };
  const getDescriptionValue = (val, _description = "") => {
    let descriptionItem = val
      .split(". ")
      .map((t) => t.trim())
      .join(".");
    let desc =
      (_description.split(". ")[0]
        ? _description.split(". ")[0].trim()
        : " ") +
      ". " +
      descriptionItem;

    let weightProps = [
      "lb",
      "lbs",
      "gram",
      "grams",
      "pound",
      "pounds",
      "lb.",
      "lbs.",
      "gram.",
      "grams.",
      "pound.",
      "pounds.",
    ];
    function endsWithAny(suffixes, string) {
      return suffixes.some(function (suffix) {
        return string.endsWith(suffix);
      });
    }

    if (!endsWithAny(weightProps, desc)) {
      if (
        _description.split(". ")[0].trim() === "Costume Jewelry" ||
        _description.split(". ")[0].trim() === "Silver Plate"
      ) {
        desc = desc + " " + "lbs";
      } else if (_description.split(". ")[0].trim() !== "Other") {
        desc = desc + " " + "grams";
      }
    }

    if (_description.split(". ")[2]) {
      desc = desc + ". " + _description.split(". ")[2].trim();
    }
    return desc
  }
  const changeDesctriptionValue = (val, item, i) => {
    let descriptionItem = val
      .split(". ")
      .map((t) => t.trim())
      .join(".");
    let desc =
      (item.description.split(". ")[0]
        ? item.description.split(". ")[0].trim()
        : " ") +
      ". " +
      descriptionItem;

    let weightProps = [
      "lb",
      "lbs",
      "gram",
      "grams",
      "pound",
      "pounds",
      "lb.",
      "lbs.",
      "gram.",
      "grams.",
      "pound.",
      "pounds.",
    ];
    function endsWithAny(suffixes, string) {
      return suffixes.some(function (suffix) {
        return string.endsWith(suffix);
      });
    }

    if (!endsWithAny(weightProps, desc)) {
      if (
        item.description.split(". ")[0].trim() === "Costume Jewelry" ||
        item.description.split(". ")[0].trim() === "Silver Plate"
      ) {
        desc = desc + " " + "lbs";
      } else if (item.description.split(". ")[0].trim() !== "Other") {
        desc = desc + " " + "grams";
      }
    }

    if (item.description.split(". ")[2]) {
      desc = desc + ". " + item.description.split(". ")[2].trim();
    }
    let items = [...newItems];
    items[i] = { ...items[i], description: desc };
    setNewItems(items);
  };

  //-----------return weight value from item object ----------
  const getWeightFromString = (item) => {
    return item.description.split(". ")[2]
      ? item.description.split(". ")[2].split(":")[1].split(")")[0].trim()
      : "";
  };

  const setCursorPosition = (inputElem, position) => {
    if (inputElem.setSelectionRange) {
      inputElem.focus();
      inputElem.setSelectionRange(position, position);
    }
  }

  const handleSubmit = (i = 0) => {
    let availableItems = newItems.filter((it) => {
      return it.description.split(". ").map(s => s.trim()).filter(p => p !== "" && p !== "grams" && p !=="lbs").length > 1
    });
    let requiredModelSerial = [];
    if (availableItems.length > 0) {
      for(let index=0; index < newItems.length; index++) {
        let containKeyword = requiredItemDescriptions.findIndex(t=>newItems[index].description.includes(t));
        if(containKeyword >= 0 && (newItems[index].model.length === 0 || newItems[index].serial.length === 0)) {
          requiredModelSerial.push('Line ' + (index+1) + ': Model & Serial fields are required.');
        }
      }
    }
    if (availableItems.length === 0) {
      let html = (
        <ul>
          <li>
            <h5 className="text-white">
              *Item Material and Description is required for all items.
            </h5>
          </li>
        </ul>
      );
      toast.error(html, {
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (requiredModelSerial.length > 0) {
      toast.error(requiredModelSerial.join('\n'), {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      document.getElementById("add-all-items").disabled = true;
      PostApiWithAuthorizationAction("metro-tickets/add-new-items-in-edit", {
        ticketId: props.match.params.id,
        allItems: availableItems.map((it) => {
          return {
            ...it,
            propertyCode: it.itemType.split(" ")[0].trim(),
            ticketId: props.match.params.id,
            soldTo: "",
            description: getDescriptionValue(it.description.split(". ")[1]
            ? it.description.split(". ")[1].trim().replace('grams', '').replace('lbs', '')
            : " ", it.description)
          };
        }),
      })
        .then((res) => {
          document.getElementById("description"+i).focus()
          document.getElementById("add-all-items").disabled = false;
          //toast.success("Successfully Added");
          props.fetchTicketItemsListingSuccess({
            data: res.data,
            ticketDetails: res.ticketDetails,
          });
          setNewItems([
            {
              ... defaultVal,
              description: newItems[0].description.split(". ")[0].trim(),
              itemType: newItems[0].itemType
            }
          ]);
          setTimeout(function() {
            setCursorPosition(document.getElementById('description' + i), 0)
          }, 50)
        })
        .catch((err) => {
          document.getElementById("add-all-items").disabled = false;
          if (err.status === 440) {
            toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
            props.history.push("/auth/login");
          } else {
            console.log(err);
            toast.error("Something went wrong! /n Please clear and retry", {
              position: toast.POSITION.TOP_CENTER,
            });
          }
        });
    }
  };
  return (
    <>
      <Table className="metro-add-item" borderless responsive="sm">
        <tbody>
          <tr>
            <th style={{ minWidth: "90px" }}>QTY</th>
            <th style={{ minWidth: "300px" }}>Item Description</th>
            <th style={{ width: "80px" }}>Unit</th>
            <th style={{ width: "80px" }}>Total</th>
            {(newItems.length < 10) && (
            <th style={{ width: "100px" }}></th>
            )}
          </tr>
          {newItems.map((it, i) => {
            let itemDescription = it.description.split(". ").filter((v, i)=>i>0).join('. ')
            return (
              <tr key={i} id={"row"+i}>
                <td>
                  {/*<FormGroup className="m-0">
                    <DropdownList
                      className="text-left"
                      placeholder="Select"
                      containerClassName="metro-type-drop"
                      data={itemType}
                      placeholder="Select"
                      value={it.itemType}
                      onChange={(e) => {
                        let items = [...newItems];
                        items[i] = { ...items[i], itemType: e };
                        setNewItems(items);
                      }}
                    />
                  </FormGroup>*/}
                  <DropdownList
                    id="create-qty"
                    data={quantityOptions}
                    direction="down"
                    value={it.qty}
                  />
                </td>
                <td>
                  <Row>
                    <Col xs={12} md={6} style={{paddingRight: 0}}>
<DropdownList
                    id="create-item"
                    data={metroItems}
                    textField="name"
                    containerClassName="item-drop"
                    value={it.name}
                    onChange={(e) => {
                      changeItemValues("name", e, i);
                      if (e.name.toLowerCase() === "eth") {
                        changeItemValues("unit", ethSpotPrice, i);
                        changeItemValues("qty", it.cost
                        ? (
                            parseFloat(it.cost) /
                            parseFloat(ethSpotPrice)
                          ).toFixed(8)
                        : "", i);
                      } else if (e.name.toLowerCase() === "btc") {
                        changeItemValues("unit", btcSpotPrice, i);
                        changeItemValues("qty", it.cost
                        ? (
                            parseFloat(it.cost) /
                            parseFloat(btcSpotPrice)
                          ).toFixed(8)
                        : "", i);
                      } else {
                        changeItemValues("unit", it.cost
                        ? it.cost / it.qty
                        : "0.00", i);
                        changeItemValues("qty", it.name &&
                        it.name.name.toLowerCase() !== "eth" &&
                        it.name.name.toLowerCase() !== "btc"
                          ? it.qty
                          : 1, i);
                      }
                    }}
                  />
                    </Col>
                    <Col xs={12} md={6} style={{paddingLeft: "5px"}}>
                      <div className="d-flex align-items-center w-100">
                        <Input
                          id={"description"+i}
                          tabIndex={it.description.split(". ")[0].trim() != 'Other' ? i+1 : 0}
                          type="text"
                          className="form-control mr-1"
                          placeholder="Description"
                          value={ itemDescription }
                          onKeyDown={handleKeyDown}
                          onChange={(e) => {
                            let newValue = e.target.value;
                            let desc = it.description.split(". ")[0].trim() + ". " + newValue;
                            let items = [...newItems];
                            items[i] = { ...items[i], description: desc };
                            setNewItems(items);
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                </td>
                <td>${it.unit && parseFloat(it.unit).toFixed(2)}</td>
                <td>
                  <Input
                    id="create-cost"
                    type="number"
                    value={it.cost}
                    onChange={(e) => {
                      changeItemValues("cost", e.target.value, i);
                    }}
                    onBlur={(e) => {
                      if (
                        it.name &&
                        it.name.name.toLowerCase() === "btc"
                      ) {
                        changeItemValues("unit", btcSpotPrice, i);
                        changeItemValues("qty", (
                          parseFloat(e.target.value) /
                          parseFloat(btcSpotPrice)
                        ).toFixed(8), i);
                      } else if (
                        it.name &&
                        it.name.name.toLowerCase() === "eth"
                      ) {
                        changeItemValues("unit", ethSpotPrice, i);
                        changeItemValues("qty", (
                          parseFloat(e.target.value) /
                          parseFloat(ethSpotPrice)
                        ).toFixed(8), i);
                      } else {
                        changeItemValues("unit", e.target.value / it.qty, i);
                      }
                    }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </td>
                {(newItems.length < 10) && (i==newItems.length-1) && (
                <td className="text-left">
                  <div className="ml-2">
                    <Button
                      id={"add-item"+i}
                      className="add-btn"
                      color="primary"
                      onClick={(e) => addRowBelow(i)}
                    >
                      + Add Rows
                    </Button>
                    {/*
                    <Button
                      id={"remove-item"+i}
                      className="add-btn"
                      color="primary"
                      onClick={(e) => removeRow(i)}
                    >
                      - Remove Row
                    </Button>*/}
                  </div>
                </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </Table>
      <div className="text-center my-2">
        <Button id="add-all-items" className="px-3 py-1" color="primary" onClick={(e) => {
          e.preventDefault();
          handleSubmit()
        }}>
          Add all Items
        </Button>
      </div>
    </>
  );
}

export default AddCoinItems;